import React, { useEffect, useState } from 'react';
import { Container, Grid, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { antiForgeryFormOptions } from '../common/antiForgery';
import { routes } from '../common/routes';
import { SpinnerComponent } from '../common/spinnerComponent';
import { signUpActivate } from '../data/endpointServices';
import { TitleText } from '../common/titleText';
import { MessageText } from '../common/messageText';

export const SignUpActivate = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [welcomeMessage, setWelcomeMessage] = useState<string>('');
    const [showSignInButton, setShowSignInButton] = useState<boolean>(false);
    const antiForgeryOptions = antiForgeryFormOptions();

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    const getSignUpActivate = async() => {
        try {
            if(code) {
                const response = await signUpActivate(code, antiForgeryOptions);
                if (response) {
                    setWelcomeMessage(t('welcomeToWeatherbug'));
                    setShowSignInButton(true);
                }
            } else {
                setWelcomeMessage(t('accountUserActivationError'));
                setShowSignInButton(true);
            }
        } catch (error) {
            if (error?.response?.data?.c === 404) {
                setWelcomeMessage(t('accountCodeActivationError'));
                setShowSignInButton(false);
            } else if (error?.response?.data?.c === 409) {
                setWelcomeMessage(t('accountUserActivationError'));
                setShowSignInButton(true);
            } else {
                setWelcomeMessage(t('signUpSystemError'));
                setShowSignInButton(false);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getSignUpActivate();
    }, [code]);

    return(
        <SignUpSuccessContainer>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TitleText>{t('accountActivation')}</TitleText>
                    <MessageText>{welcomeMessage}</MessageText>
                </Grid>
                {loading && <SpinnerComponent />}
                {showSignInButton
                    && <Grid item xs={12}>
                        <StyledLink to={routes.logIn}>
                            <GoToSignInButton
                                fullWidth
                                variant='outlined'
                                disableElevation
                            >
                                {t('signIn')}
                            </GoToSignInButton>
                        </StyledLink>
                    </Grid>
                }
            </Grid>
        </SignUpSuccessContainer>
    );
};

const SignUpSuccessContainer = styled(Container)`
    margin-top: 50px;
`;

const StyledLink = styled(Link)`
    text-decoration: none;
    width: 100%;
`;

const GoToSignInButton = styled(Button)`
    color: #ffffff;
    background-color: #0083C6;
`;
